<template>
  <div v-if="value" class="modal-child-backdrop" @click.self="onBackdropClick">
    <div
      class="modal-child-dialog"
      role="dialog"
      aria-modal="true"
      :aria-label="title"
      :style="{ width: dialogWidth }"
    >
      <div class="modal-child-header">
        <span class="modal-child-title">{{ title }}</span>
        <button class="modal-child-close" type="button" :title="closeTitle" @click="close">
          <i class="fa-solid fa-xmark"></i>
        </button>
      </div>
      <div class="modal-child-body" :style="bodyStyle">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ModalChild",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    width: {
      type: [Number, String],
      default: 420,
    },
    maxHeight: {
      type: [Number, String],
      default: null,
    },
    bodyPadding: {
      type: String,
      default: "14px 16px",
    },
    closeOnBackdrop: {
      type: Boolean,
      default: true,
    },
    closeOnEsc: {
      type: Boolean,
      default: true,
    },
    closeTitle: {
      type: String,
      default: "Fechar",
    },
  },
  computed: {
    dialogWidth() {
      if (typeof this.width === "number") return `${this.width}px`;
      return this.width;
    },
    bodyStyle() {
      const style = { padding: this.bodyPadding };
      if (this.maxHeight) {
        style.maxHeight = typeof this.maxHeight === "number" ? `${this.maxHeight}px` : this.maxHeight;
        style.overflowY = "auto";
      }
      return style;
    },
  },
  mounted() {
    window.addEventListener("keydown", this.onKeyDown);
  },
  beforeDestroy() {
    window.removeEventListener("keydown", this.onKeyDown);
  },
  methods: {
    close() {
      this.$emit("input", false);
      this.$emit("close");
    },
    onBackdropClick() {
      if (this.closeOnBackdrop) this.close();
    },
    onKeyDown(e) {
      if (e.key === "Escape" && this.value && this.closeOnEsc) this.close();
    },
  },
};
</script>

<style scoped>
.modal-child-backdrop {
  position: fixed;
  inset: 0;
  z-index: 9998;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.25);
}

.modal-child-dialog {
  max-width: calc(100vw - 24px);
  max-height: calc(100vh - 48px);
  background: var(--bg-base);
  border: 1px solid var(--border-color);
  border-radius: 12px;
  box-shadow: var(--shadow-lg);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.modal-child-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 14px 16px 12px;
  background: var(--bg-base);
  flex-shrink: 0;
}

.modal-child-title {
  font-size: 15px;
  font-weight: 500;
  color: var(--text-primary);
}

.modal-child-close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border: none;
  background: transparent;
  color: var(--text-muted);
  cursor: pointer;
  font-size: 16px;
  transition: color 0.2s;
  padding: 0;
}

.modal-child-close:hover {
  color: var(--color-danger);
}

.modal-child-body {
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow-y: auto;
  background: var(--bg-base);
}
</style>
